module.exports = __webpack_public_path__ + "static/media/auto_tech_giants.9f774e0d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/auto_tech_giants.webp
// module id = 313
// module chunks = 0